import WeekNavigation from './WeekNavigation.view';

export default WeekNavigation;
